import script from "./LiveFixtureDoubleMarketAll.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleMarketAll.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleMarketAll.vue?vue&type=style&index=0&id=5fee6409&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fee6409"]])

export default __exports__